module.exports = __webpack_public_path__ + "img/oku.60d0899b.jpg";